const isContextMenuItem = (item) => {
    return 'selectable' in item;
};

export { isContextMenuItem };
//# sourceMappingURL=types.js.map
